module.exports = "/assets/2d3e685e69b02647fc85d2adc3ba3af7.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos-small/V3.png
// module id = 3031
// module chunks = 0